import { normalizeText } from './text'

/** Keeps significant digits, including leading zeroes, while removing separators. */
export function normalizeItemCode(value: unknown): string {
  return normalizeText(value).replace(/[\s._/\\-]+/gu, '')
}

export function codeFragments(value: unknown): readonly string[] {
  const code = normalizeItemCode(value)
  if (!code) return []

  const fragments = new Set<string>([code])
  const alphanumericParts = normalizeText(value).match(/[\p{L}\p{N}]+/gu) ?? []
  for (const part of alphanumericParts) {
    if (part.length >= 2) fragments.add(part)
  }
  if (code.length >= 4) {
    fragments.add(code.slice(0, 4))
    fragments.add(code.slice(-4))
  }
  return [...fragments].sort()
}
